import Vue from "vue"
import LocalizationSwitcher from "@components/LocalizationSwitcher"

let localizationSwitcher = document.querySelector(".landing-localization-switcher")

if (document.getElementById("localizationSwitcher")) {
    new Vue({
        el: "#localizationSwitcher",
        components: {
            LocalizationSwitcher: LocalizationSwitcher
        },
        methods: {
            close() {
                localizationSwitcher.style.display = "none"
            }
        }
    })
}

function changeLanguage(val) {
    window.location = `/locale/${val}`
}

window.changeLanguage = changeLanguage

function openLocalizationSwitcher() {
    localizationSwitcher.style.display = "block"
}

window.openLocalizationSwitcher = openLocalizationSwitcher
